module.exports = __webpack_public_path__ + "img/icon_profile_active_mob.fc5c3775.svg";